/* Feedback only: retain Shopify's native form action and checkout submitter. */
(() => {
  'use strict';
  const pending = new Map();
  function reset(button, retry = false) {
    const state = pending.get(button);
    if (!state) return;
    clearTimeout(state.timer);
    button.classList.remove('sm-checkout-opening');
    if (state.busy === null) button.removeAttribute('aria-busy');
    else button.setAttribute('aria-busy', state.busy);
    if (state.status) state.status.textContent = retry ? state.status.dataset.retryMessage : '';
    pending.delete(button);
  }
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    const button = event.submitter || document.activeElement;
    if (!button?.matches('.cart__checkout-button[name="checkout"]') || button.form !== event.target || button.disabled || pending.has(button)) return;
    const label = button.querySelector('.sm-checkout-loading');
    if (!label) return;
    const status = document.getElementById(button.id + '-status');
    const state = { busy: button.getAttribute('aria-busy'), status, timer: null };
    pending.set(button, state);
    button.classList.add('sm-checkout-opening');
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = label.textContent.trim();
    // Never disable the button: its name=checkout must remain in the native POST.
    state.timer = setTimeout(() => reset(button, true), 15000);
    queueMicrotask(() => { if (event.defaultPrevented) reset(button); });
  });
  window.addEventListener('pageshow', () => { for (const button of pending.keys()) reset(button); });
})();
